import * as _ from "lodash";

export const RoleCode = {
  "Admin": 1,
  "Supervisor": 2,
  "ML": 3,
  "TALead": 4,//MSL Leader
  "CRP": 5,
  "CRPLeader": 6,
  "CVEO": 7,
  "CVEOLeader": 8,
  "SciCom": 9,
  "SciComLeader": 10,
  "ClinTrans": 11,
  "ClinTransLeader": 12,
  "VMSL": 13,
  "CallCenter": 14,
}

export const HcpType = {
  "SE": "SE",
  "CE": "CE",
  "vCE": "vCE",
  "Customer": "Customer",
}
export const BasicRoles = [
  "d271d4c8-cc66-4327-8911-47ba35dc57df", // Admin
  "3ddd8bc6-c5ac-432d-ab0b-05d0e59d5d6e", // ML
  "d3eb0bb1-1752-41aa-8e62-11015ff6b2a2", // MSL
  "75bed9cc-3fc7-4e81-bdfc-962f9d394946", // SV
  "abb4cd4c-4a81-4591-9f29-c25f6691a8a9", // vML
  "522d6b01-4ad8-4222-865d-20dc67460898", // Call Center
]

export const CRPGroup = [
  "94a2ff8d-a5f0-405a-abbb-2aee8be126d5", // CRP
  "0cb6ab37-2ab0-4123-80bd-c3e1f12adc32"  // CRP Leader
]

export const SciComGroup = [
  "a2b2b73d-67ed-4f72-9428-8c791e8432f7", // SciCom
  "dd9472ff-e3a6-42da-b8bb-7796e026d82a"  // SciCom Leader
]

export const CVEOGroup = [
  "751a30aa-4fea-4388-98d3-778003cb8e71", // CVEO
  "ece81c6e-aae5-45c2-8bdb-bf86e3c40e1f"  // CVEO Leader
]

export const ClinTransGroup = [
  "84e3a762-be15-4c2c-8cfb-5c6aff988ac5", // Clin-trans
  "1bb1860e-5dea-4568-bd42-e64bee93081b"  // Clin-trans-Leader
]

export const LeaderLabelValues = {
  "75bed9cc-3fc7-4e81-bdfc-962f9d394946": {
    label: "MSL Leader",
    value: "msl"
  },
  "94a2ff8d-a5f0-405a-abbb-2aee8be126d5": {
    label: "CRP Leader",
    value: "crpl"
  },
  "a2b2b73d-67ed-4f72-9428-8c791e8432f7": {
    label: "SciCom Leader",
    value: "scicoml"
  },
  "751a30aa-4fea-4388-98d3-778003cb8e71": {
    label: "CVEO Leader",
    value: "cveol"
  },
  "84e3a762-be15-4c2c-8cfb-5c6aff988ac5": {
    label: "Clinical Transformation Leader",
    value: "clin-transl"
  }
}


export function findRoleGroupById(id, roleList = []) {
  const roleIdGroups = [BasicRoles, CRPGroup, SciComGroup, CVEOGroup, ClinTransGroup];
  const roleIdGroup = _.find(roleIdGroups, group => {
    return _.some(group, roleId => roleId === id);
  });
  return _.filter(roleList, role => {
    return _.some(roleIdGroup, roleId => roleId === role.RoleID)
  });
}

export function parseSubRoleName(role) {
  switch (role) {
    case RoleCode.CRPLeader:
      return "CRP";
    case RoleCode.SciComLeader:
      return "SciCom";
    case RoleCode.CVEOLeader:
      return "CVEO";
    case RoleCode.ClinTransLeader:
      return "Clin-trans";
    case RoleCode.Admin:
      return "User";
    default:
      return "MSL"
  }
}